import axios from "../../../axios/index.js"
// import store from "../../../../store/store.js"

// Token Refresh
// let isAlreadyFetchingAccessToken = false
// let subscribers = []

// function onAccessTokenFetched(access_token) {
//   subscribers = subscribers.filter(callback => callback(access_token))
// }
//
// function addSubscriber(callback) {
//   subscribers.push(callback)
// }

export default {

  // init() {
  //   //TODO :: 향후 수정이 필요함.
  //   var token =''
  //   if(localStorage.getItem("filleduToken")){
  //     token = localStorage.getItem("filleduToken")
  //   } else if (sessionStorage.getItem("filleduToken")) {
  //     token = sessionStorage.getItem("filleduToken")
  //   }
  //   if (token){
  //     // return new Promise((resolve, reject) => {
  //     this.initTest()
  // //   }).catch(error => { reject(error) })
  // // })
  //   }
  //   axios.interceptors.response.use(function (response) {
  //     //console.log(response)
  //     return response
  //   }, function (error) {
  //     // const { config, response: { status } } = error
  //     const { config, response } = error
  //     const originalRequest = config
  //
  //     // if (status === 401) {
  //     if (response && response.status === 401) {
  //       if (!isAlreadyFetchingAccessToken) {
  //         isAlreadyFetchingAccessToken = true
  //         store.dispatch("auth/fetchAccessToken")
  //           .then((response) => {
  //             isAlreadyFetchingAccessToken = false
  //             onAccessTokenFetched(response)
  //           })
  //       }
  //
  //       const retryOriginalRequest = new Promise((resolve) => {
  //         addSubscriber(access_token => {
  //           // originalRequest.headers.Authorization = 'Bearer ' + access_token
  //           originalRequest.defaults.headers.common['authorization'] = 'token=' + access_token
  //           resolve(axios(originalRequest))
  //         })
  //       })
  //       return retryOriginalRequest
  //     }
  //     return Promise.reject(error)
  //   })
  // },
  login(email, pwd) {
    var loginInfo = {"email": email, "password": pwd}
    return axios.post("/api/auth/login", loginInfo)
  },
  registerUser(name, email, pwd) {
    return axios.post("/api/auth/register", {displayName: name, email: email, password: pwd})
  },
  refreshToken() {
    var token =''
    if(localStorage.getItem("filleduToken")){
      token = localStorage.getItem("filleduToken")
    } else if (sessionStorage.getItem("filleduToken")) {
      token = sessionStorage.getItem("filleduToken")
    }
    if (token){
      return axios.post("/api/auth/refresh-token", { accessToken:token})
    }
    return Promise.reject('NOT TOKEN')
  },
  initTest() {
    return new Promise((resolve, reject) => {
      this.refreshToken().then(response => {
        // console.log('initTest ' + response.data.token)
        resolve(response)
      }).catch(error => { reject(error) })
    })
  },
  init(){
    return new Promise((resolve, reject) => {
      var token =''
      if(localStorage.getItem("filleduToken")){
        token = localStorage.getItem("filleduToken")
      } else if (sessionStorage.getItem("filleduToken")) {
        token = sessionStorage.getItem("filleduToken")
      }
      console.log(token)
      if (token){
        axios.post("/api/auth/refresh-token", { accessToken:token}).then((response)=>{
          axios.defaults.headers.common['authorization'] = 'token=' + response.data.token
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      }
      else{
        reject('NOT TOKEN')
      }
    })
  }
}
